import { type ItemResponse, type BaseRequestConfig } from '@bv/api/base';
import { WithPagination } from '@bv/api/crud/with-pagination';

import type { AiAgentReportData } from '@/types/api/reports/AiAgentReport';

/**
 * Manages AI agent call interaction reports.
 */
class AiAgentReportApi extends WithPagination<AiAgentReportData> {
  public constructor(public endpoint = 'reports/ai-calls') {
    super(endpoint);
  }

  public async exportToEmail(config: BaseRequestConfig = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: 'export',
      data: config.data,
      headers: config.headers,
      params: config.params,
    }).then((response) => response.data);
  }

  public async getCallRecordingUrl(callId: string | number): Promise<string> {
    return this.request<{ recording: string }, ItemResponse<{ recording: string }>>({
      method: 'get',
      url: `${callId}/recording`,
    }).then((response) => response.data.recording);
  }
}

export const aiAgentReportApi = new AiAgentReportApi();
// TODO: remove old AI agent report version
export const aiAgentReportOldApi = new AiAgentReportApi('ai-agent/reports/calls');
